<template>
  <div class="text-center py-4 bg-brand-50 font-bold">Sorry, this component failed to render. Please try refreshing your browser.</div>
</template>
